module.exports = __webpack_public_path__ + "img/level-5.da4eb908.svg";